/**
 * Created by shem.mahluf on 24/04/2017.
 */

import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import App from '../App';
import { Provider } from 'react-redux';
import configure from '../../store';
import C_ROUTES from '../../constants/routes';

const store = configure();
if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../../reducers', () => {
        const nextReducer = require('../../reducers').default;
        store.replaceReducer(nextReducer)
    })
}

class Main extends Component {
    render() {
        return (
            <Provider store={ store }>
                <Router basename={C_ROUTES.SERVICE_PORTAL_PATH} >
                    <App />
                </Router>
            </Provider>
        );
    }
}

 export default Main;



// WEBPACK FOOTER //
// ./containers/Main/index.js